module.exports = __webpack_public_path__ + "img/neo-bg-image.68df2a6d.webp";